export enum ChatState {
  CONTEXT_WINDOW_EXCEEDED = 'CONTEXT_WINDOW_EXCEEDED',
  GOOD = 'GOOD',
}
